import React from "react";

const ConfirmDeleteModal = ({ open, onClose, onConfirm, loading, target, isFolder }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
        <h3 className="text-lg font-bold mb-4">Delete Confirmation</h3>
        <p className="mb-4">
          Are you sure you want to delete
          <span className="font-semibold"> {target?.name} </span>
          {isFolder ? "and all its contents?" : "?"}
        </p>
        <div className="flex justify-end space-x-2">
          <button className="px-4 py-2 bg-gray-200 rounded" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="px-4 py-2 bg-red-600 text-white rounded" onClick={onConfirm} disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
